import { useSelector } from "react-redux";
import { snapshotImage, StreamType } from "../../../hoc/snapshotImage";
import { BasicSnapshot } from "../../../global/components/snapshots/BasicSnapshot";
import { Line } from "@vds/lines";
import { Body } from "@vds/typography";
import  "../../../styles/global.css"
import { ON_BOARD_TYPE_MANNUAL } from "../../../global/constants/devices";

const SnapshotSection = (props) => {
  const { companionDevice, selectedCamQR, fovIds } = useSelector(
    (state) => state.cameraOnboardingReducer
  );
  const primaryStreamFromModal = useSelector(
    (state) => state.cameraOnboardingReducer.modalOpenObj?.streamId
  );

 
  const onBoradType = props?.onBoradType;
  const ManualfieldOfViews = fovIds || props?.fovData || [];
  const AutofieldOfViews =
    useSelector((state) => state.cameraOnboardingReducer.fovIds) || [];
  const fieldOfViews =
    onBoradType === ON_BOARD_TYPE_MANNUAL ? ManualfieldOfViews : AutofieldOfViews;
  const fovIdsForSelectedCameraQA = fieldOfViews?.map((item) => item.fovId);
  const primaryFovId = primaryStreamFromModal ?? fovIdsForSelectedCameraQA?.[0];
  return (
    <>
      {onBoradType === ON_BOARD_TYPE_MANNUAL && (
        <Body size="large">
          Select the floor plan that corresponds with the location of this
          camera. Then, drag and drop the camera icon so that its location on
          the floor plan corresponds to it's location on your site. You can zoom
          in on the map to increase accuracy of placement."
        </Body>
      )}
      <br />
      {onBoradType !== ON_BOARD_TYPE_MANNUAL && <div className="sasp_d" >
        {primaryFovId && (() => {
          const fovid = primaryFovId;
          if (
            props?.editFlow == false &&
            (companionDevice?.id || props?.companionData?.id)
          ) {
            const SnapshotImg = snapshotImage(
              BasicSnapshot,
              fovid,
              selectedCamQR ? selectedCamQR : props?.selectCameraQr,
              StreamType.UNPAIRED_CAMERA,
              companionDevice?.id
                ? companionDevice?.id
                : props?.companionData?.id
            );
            return <SnapshotImg width="109.09px" height="69.14px" />;
          } else if (companionDevice?.id || props?.companionData?.id) {
            const SnapshotImg = snapshotImage(
              BasicSnapshot,
              fovid,
              selectedCamQR ? selectedCamQR : props?.selectCameraQr,
              StreamType.PAIRED_CAMERA
            );
            return (
              <SnapshotImg
                width="109.09px"
                height="69.14px"
                refreshImage={false}
              />
            );
          }
          return null;
        })()}
      </div>}
      <br />
      {companionDevice?.id && <Line type="secondary" />}
    </>
  );
};

export default SnapshotSection;
